// Estado de un sub-usuario en la pantalla Usuarios.
//
// «Dado de baja» lo decide soporte desde la consola (`User.is_active`): el dueño no puede
// revertirlo, así que no se le ofrece «Reactivar» (antes la fila decía «Activo» y el botón
// suspendía a alguien que de todos modos ya no podía entrar). `isActive` ausente = activo, para
// tolerar un backend anterior.
export function subUserStatus(subUser) {
    if (subUser.isActive === false) {
        return { label: 'Dado de baja', severity: 'danger', canToggle: false };
    }
    if (subUser.suspended) {
        return { label: 'Suspendido', severity: 'danger', canToggle: true };
    }
    return { label: 'Activo', severity: 'success', canToggle: true };
}

// «Reportar transacciones» del sub-usuario (H23): nace con el valor del dueño y, con
// Contabilidad activa, es siempre «Sí». `null` si el backend no lo manda (versión anterior).
export function autoTransactionsLabel(subUser, ownerValue) {
    if (subUser.autoTransactions === undefined || subUser.autoTransactions === null) return null;
    const value = subUser.autoTransactions ? 'Sí' : 'No';
    const sameAsOwner = ownerValue !== undefined && ownerValue !== null && !!ownerValue === !!subUser.autoTransactions;
    return `Reportar transacciones: ${value}${sameAsOwner ? ' (como el dueño)' : ''}`;
}
